import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Observable} from 'rxjs';
import {ToastService, Toast as ToastModel} from '../../services/toast.service';

@Component({
    selector: 'app-toast',
    imports: [CommonModule],
    templateUrl: './toast.html',
    styleUrl: './toast.css'
})
export class Toast {
    toasts$: Observable<ToastModel[]>;
    toastService = inject(ToastService);

    constructor() {
        this.toasts$ = this.toastService.toasts$;
    }

    trackToast(index: number, toast: ToastModel): string {
        return toast.id;
    }

    removeToast(id: string): void {
        this.toastService.removeToast(id);
    }

    clearAllToasts(): void {
        this.toastService.clear();
    }


    getToastClasses(type: string): string {
        const baseClasses = 'alert alert-soft animate-slide-in';

        switch (type) {
            case 'success':
                return `${baseClasses} alert-success`;
            case 'error':
                return `${baseClasses} alert-error`;
            case 'warning':
                return `${baseClasses} alert-warning`;
            case 'info':
                return `${baseClasses} alert-info`;
            default:
                return `${baseClasses}`;
        }
    }
}
